import React, { Component } from 'react';
import {
	// SelectInput,
	LongTextInput,
	Responsive,
} from 'admin-on-rest';
import {
	ReferenceInput,
} from 'admin-on-rest/lib/mui';
import EmbeddedArrayInput from '../inputs/EmbeddedArrayInput'
import DisabledStatusChip from '../inputs/DisabledStatusChip'
import ActionDoneIcon from 'material-ui/svg-icons/action/done';
import RaisedButton from 'material-ui/RaisedButton'
import { dateNow, getUserID } from '../util'
import LongDisabledInput from '../inputs/LongDisabledInput'
import SelectInput from '../SelectInput'

const docDefDefaults = {
	status: 'pending',
	name: '',
	document_other_name: '',
	added_date: dateNow(),
	complied_date: '',
	complied_confirmed_date: '',
	waived_date: '',
	rejected_date: '',
	remark: '',
	added_by_user: getUserID(),
	complied_by_user: '',
	confirmed_by_user: '',
}

const PendingDocActions = (props) => {
	const { index, items } = props

	const item = items.get( index );
	const { status } = item;

	const complyItem = () => {
		const currentItem = items.get( index )
		const newItem = {
			...currentItem,
			status: 'complied',
			complied_date: dateNow(),
			complied_by_user: getUserID(),
		}
		items.remove( index )
		items.insert( index, newItem )
	}

	const compliedButton = (
		status === 'pending' || status === 'compliance_rejected' ?
			<RaisedButton label="Complied" icon={<ActionDoneIcon />} primary onClick={complyItem}/>
		: null
	)

	return (
		<div style={{ display: 'flex', alignItems: 'center' }}>
			{compliedButton}
		</div>
	)
}

const disableFunc = ( record, index ) => {
	if ( ! record.fields ) {
		return true
	}
	if ( ! record.fields.doc_defs ) {
		return true
	}
	const { status } = record.fields.doc_defs[ index ]
	return status !== 'pending' && status !== 'compliance_rejected'
}

class DCDocDefEditTab extends Component {
	render() {
		return (
			<div className="doc-def">
				<Responsive {...this.props}
					large={
						<EmbeddedArrayInput label="" source="fields.doc_defs" actions={PendingDocActions} forceInputActions={true} defaults={docDefDefaults} allowAdd={false} readOnlyFunc={true} >
							<DisabledStatusChip label="Status" source="status" disabledType={DisabledStatusChip}/>
							<ReferenceInput label="Document" source="name" reference="pending_docs" allowEmpty validation={{ required: true }} style={{ display: 'inline-block', marginRight: 32, width: 280 }}>
								<SelectInput source="name" options={{ disabled: true }}/>
							</ReferenceInput>
							<LongTextInput label="Document Name (If 'other' is chosen)" source="document_other_name" disableFunc={() => true} style={{ display: 'inline-block', width: 'calc(100% - 280px - 32px)', verticalAlign: 'top', maxWidth: 500, minWidth: 280 }} disabledType={LongDisabledInput} />
							<LongTextInput label="Remarks" source="remark" disableFunc={disableFunc} disabledType={LongDisabledInput} />
						</EmbeddedArrayInput>
					}
				/>
			</div>
		)
	}
}

export default DCDocDefEditTab;



// WEBPACK FOOTER //
// ./src/DCAccount/DocDefEditTab.js